import React, { useContext } from 'react';
import { AuthContext } from '../context/AuthContext';
import { Link } from 'react-router-dom';
import '../assets/css/header.css'; // Ensure this file exists

const Header = () => {
  const { auth, logout } = useContext(AuthContext);

  const getUserRole = () => {
    if (!auth?.token) return null;
    try {
      const payload = JSON.parse(atob(auth.token.split('.')[1]));
      return payload.role;
    } catch (e) {
      return null;
    }
  };

  const role = getUserRole();

  return (
    <header className="custom-header">
      <div className="left-menu">
        <Link to="/dashboard">Dashboard</Link>
        {(role === "admin" || role === "user") && (
          <>
            <Link to="/ai-agents">AI Agents</Link>
            <Link to="/ai-agents/create">Create Agent</Link>
          </>
        )}
      </div>
      <div className="right-menu">
        <span className="user-role">Role: <strong>{role}</strong></span>
        <button className="logout-btn" onClick={logout}>Logout</button>
      </div>
    </header>
  );
};

export default Header;
